module.exports = __webpack_public_path__ + "static/media/Arceus_gaussian2.97447ce3.png";